import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3077383669/src/node_modules/@mui/material/Box/Box.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3077383669/src/node_modules/@mui/material/Card/Card.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3077383669/src/node_modules/@mui/material/CardContent/CardContent.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3077383669/src/node_modules/@mui/material/CardMedia/CardMedia.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3077383669/src/node_modules/@mui/material/Grid/Grid.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3077383669/src/node_modules/@mui/material/Typography/Typography.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/codebuild/output/src3077383669/src/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3077383669/src/src/lib/components/ArchiveSidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3077383669/src/src/lib/components/BottomPagination.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3077383669/src/src/lib/components/TagChip.tsx");
